import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { switchMap, map, catchError, of, withLatestFrom, tap } from "rxjs";
import { ContractClient } from "src/api-service";
import { selectSelectedCompany } from "../../../../user/user.selectors";
import { normalizeError } from "../../../../app-store-error.types";
import { ContractReportsActions } from "./contract-reports.actions";

@Injectable()
export class ContractReportsEffects {
    private readonly actions$ = inject(Actions);
    private readonly store = inject(Store);
    private readonly contractClient = inject(ContractClient);

    generateContractReport$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ContractReportsActions.generateContractReport),
            withLatestFrom(this.store.select(selectSelectedCompany)),
            switchMap(([{ request }, selectedCompany]) =>
                this.contractClient.generateReport(request, String(selectedCompany!.id)).pipe(
                    map(response => ContractReportsActions.generateContractReportSuccess({ response })),
                    catchError(error =>
                        of(ContractReportsActions.generateContractReportFailure({
                            error: normalizeError(error),
                            toastKey: "ADMIN.SUPER_USER.CONTRACTS.REPORTS.TOAST.GENERATE_ERROR",
                        })),
                    ),
                ),
            ),
        ),
    );

    exportContractReportExcel$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ContractReportsActions.exportContractReportExcel),
            withLatestFrom(this.store.select(selectSelectedCompany)),
            switchMap(([{ request }, selectedCompany]) =>
                this.contractClient.generateExcelReport(request, String(selectedCompany!.id)).pipe(
                    tap(response => {
                        const blob = response.data;
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.href = url;
                        a.download = response.fileName ?? `Ramavtalsrapport_${new Date().toISOString().split("T")[0]}.xlsx`;
                        a.click();
                        window.URL.revokeObjectURL(url);
                    }),
                    map(() => ContractReportsActions.exportContractReportExcelSuccess({
                        toastKey: "ADMIN.SUPER_USER.CONTRACTS.REPORTS.TOAST.EXPORT_SUCCESS",
                    })),
                    catchError(error =>
                        of(ContractReportsActions.exportContractReportExcelFailure({
                            error: normalizeError(error),
                            toastKey: "ADMIN.SUPER_USER.CONTRACTS.REPORTS.TOAST.EXPORT_ERROR",
                        })),
                    ),
                ),
            ),
        ),
    );
}
